import { render, staticRenderFns } from "./optionSensitiveWordTypeDialog.vue?vue&type=template&id=3c486d4a&scoped=true&"
import script from "./optionSensitiveWordTypeDialog.vue?vue&type=script&lang=js&"
export * from "./optionSensitiveWordTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./optionSensitiveWordTypeDialog.vue?vue&type=style&index=0&id=3c486d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c486d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c486d4a')) {
      api.createRecord('3c486d4a', component.options)
    } else {
      api.reload('3c486d4a', component.options)
    }
    module.hot.accept("./optionSensitiveWordTypeDialog.vue?vue&type=template&id=3c486d4a&scoped=true&", function () {
      api.rerender('3c486d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/SenWordSettings/optionSensitiveWordTypeDialog.vue"
export default component.exports